/*eslint no-unused-vars: ["error", { "vars": "local" }]*/
/*eslint no-global-assign: "off"*/

(function ($) {
  $.fn.wsFilters = function (options) {
    if (typeof options != 'undefined' && options.constructor === String) {
      switch (options) {
        case 'initializeFilters':
          return this.each(function () {
            this.initializeFilters();
          });
        default:
          throw 'Option does not exist: ' + options;
      }
    }

    return this.each(function () {
      /*var opt = $.extend({
        delay: 100,
        speed: 10,
      }, options);*/

      // Elements
      let filtersElement;
      let filtersWrapperElement;
      let mobileFiltersButtonElement;
      let filtersSelectedPillsElement;

      // Variables
      //let hover = false;

      let bindEvents = function () {
        mobileFiltersButtonElement.click(function () {
          toggleFilterWrapperElement();
        });

        filtersWrapperElement.find('.ws-filters-close-button').click(function () {
          closeFilterWrapperElement();
        });

        $('.ws-mobile-filter-result').on('click', function() {
          toggleFilterWrapperElement();
        });
      }


      // Resize.
      let initializeFilters = this.initializeFilters = function () {
        /* global woof_draw_products_top_panel */
        woof_draw_products_top_panel = function () { };
        //$('.woof_products_top_panel').remove();

        filtersSelectedPillsElement.html('');

        if ($(window).width() <= 1024 && $('.ws-mobile-filter-result').text() !== '') {
          $('.ws-mobile-filter-result').show();
        } else {
          $('.ws-mobile-filter-result').hide();
        }

        $('.orderby, .woof_list_color, .woof_select, .woof_mselect').each (function () {
          let el = $(this);
          createFilterElement(el);
        });

        $('.woof_show_text_search').each (function () {
          let el = $(this);
          createTextFilterElement(el);
        });

        /*
        $('.woof_remove_ppi .fa-times').remove();
        $('.woof_remove_ppi').append('<i class="fas fa-times">');
        */
        /*
        let aTags = woof_products_top_panel.find('a').appendTo(woof_products_top_panel);
        woof_products_top_panel.find('ul').remove();

        aTags.find('.woof_remove_ppi .fa-times').remove();
        aTags.find('.woof_remove_ppi').append('<i class="fas fa-times">');
        */
      }

      let createFilterElement = function (el) {
        let element = el.data('ws-select');
        //console.log(element);

        if (typeof element === 'undefined') {
          // Create new element
          /*
          TODO: for mobile,
           add save button to each option dropdown, and do not save unless that is clicked (or maybe the dropdown is closed)

          */

          let optionElements = [];
          el.find('option').each(function () {
            let opt = $(this);
            //console.log(opt.text());
            if (opt.text() === '') {
              // Skip empty item (probably the first item for when you have no filter selected)
              return;
            }

            let label = opt.text();
            let color = opt.data('color');

            let optionElement = $(`
              <div class="option">
                ${label}
              </div>
            `);

            if (typeof color !== 'undefined') {
              optionElement.addClass('has-color');
              optionElement.get(0).style.setProperty('--ws-color', color);
            }
            optionElement.data('parent', opt);
            optionElement.data('parent-select', el);
            optionElement.click(optionElementClick);
            optionElements.push(optionElement);

          });

          element = $(`
            <div class="ws-select">
              <div class="placeholder">
                ${el.data('placeholder')}
                <i class="up"><svg xmlns="http://www.w3.org/2000/svg" height="1em" viewBox="0 0 320 512"><path d="M182.6 41.4c-12.5-12.5-32.8-12.5-45.3 0l-128 128c-9.2 9.2-11.9 22.9-6.9 34.9s16.6 19.8 29.6 19.8H288c12.9 0 24.6-7.8 29.6-19.8s2.2-25.7-6.9-34.9l-128-128z"/></svg></i>
                <i class="down"><svg xmlns="http://www.w3.org/2000/svg" height="1em" viewBox="0 0 320 512"><path d="M182.6 470.6c-12.5 12.5-32.8 12.5-45.3 0l-128-128c-9.2-9.2-11.9-22.9-6.9-34.9s16.6-19.8 29.6-19.8H288c12.9 0 24.6 7.8 29.6 19.8s2.2 25.7-6.9 34.9l-128 128z"/></svg></i>
                <div class="selected-items-container"></div>
              </div>
              <div class="options-container">
                <div class="options-header">
                  <div class="options-back-button">
                    <i><svg xmlns="http://www.w3.org/2000/svg" height="1em" viewBox="0 0 320 512"><path d="M41.4 233.4c-12.5 12.5-12.5 32.8 0 45.3l160 160c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3L109.3 256 246.6 118.6c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0l-160 160z"/></svg></i>
                    ${el.data('placeholder')}
                  </div>
                </div>
                <div class="options"></div>
              </div>
            </div>
          `);
          element.find('.options-back-button').click(function () {
            closeFilterElement($(this).closest('.ws-select')); //.removeClass('open');
          });
          element.find('.placeholder').click(function () {
            toggleFilterElement($(this).parent()); //.toggleClass('open');
          });
          element.find('.options').append(optionElements);
          element.data('parent', el);
          el.data('ws-select', element);

          el.after(element);
          el.hide();
        }

        // Set elements to active if needed

        updateFilterElement(el);

      }

      let updateFilterElement = function (el) {
        let selectedItemsContainer = el.data('ws-select').find('.placeholder .selected-items-container');
        selectedItemsContainer.empty();
        el.data('ws-select').find('.options .option').each(function () {
          let optionElement = $(this);
          let selected = optionElement.data('parent').prop('selected');
          //console.log(selected);
          if (selected) {
            optionElement.addClass('selected');
            selectedItemsContainer.append(optionElement.clone());
            // TODO: Skip "stock" taxonomy?
            filtersSelectedPillsElement.append(optionElement.clone(true).append('<i><svg xmlns="http://www.w3.org/2000/svg" height="1em" viewBox="0 0 352 512"><path d="M242.7 256l100.1-100.1c12.3-12.3 12.3-32.2 0-44.5l-22.2-22.2c-12.3-12.3-32.2-12.3-44.5 0L176 189.3 75.9 89.2c-12.3-12.3-32.2-12.3-44.5 0L9.2 111.5c-12.3 12.3-12.3 32.2 0 44.5L109.3 256 9.2 356.1c-12.3 12.3-12.3 32.2 0 44.5l22.2 22.2c12.3 12.3 32.2 12.3 44.5 0L176 322.7l100.1 100.1c12.3 12.3 32.2 12.3 44.5 0l22.2-22.2c12.3-12.3 12.3-32.2 0-44.5L242.7 256z"/></svg></i>'));

            if (el.attr('name') === 'pa_size') {
              // Set size in localstorage if this is the size option
              // This is to make sure the size gets selected when you go to the product
              localStorage.setItem('size', optionElement.data('parent').val());
            }
          } else {
            optionElement.removeClass('selected');
          }
        });
      }


      let createTextFilterElement = function (el) {
        let element = el.data('ws-select');
        //console.log(element);

        if (typeof element === 'undefined') {
          // Create new element
          /*
          element = $(`
            <div class="ws-select">
              <div class="placeholder">
                ${el.data('placeholder')}
                <i class="fas fa-sort-up"></i>
                <i class="fas fa-sort-down"></i>
                <div class="selected-items-container"></div>
              </div>
              <div class="options-container">
                <div class="options-header">
                  <div class="options-back-button">
                    <i class=" fas fa-angle-left"></i>
                    ${el.data('placeholder')}
                  </div>
                </div>
                <div class="options"></div>
              </div>
            </div>
          `);
          element.find('.options-back-button').click(function () {
            closeFilterElement($(this).closest('.ws-select')); //.removeClass('open');
          });
          element.find('.placeholder').click(function () {
            toggleFilterElement($(this).parent()); //.toggleClass('open');
          });
          element.find('.options').append(optionElements);
          element.data('parent', el);
          el.data('ws-select', element);

          el.after(element);*/
          el.hide();
        }

        // Set elements to active if needed

        updateTextFilterElement(el);
      }

      let updateTextFilterElement = function (el) {
        let label = $(el).val();
        if (label == '') {
          return;
        }

        let optionElement = $(`
          <div class="option">
            ${label}
            <i><svg xmlns="http://www.w3.org/2000/svg" height="1em" viewBox="0 0 352 512"><path d="M242.7 256l100.1-100.1c12.3-12.3 12.3-32.2 0-44.5l-22.2-22.2c-12.3-12.3-32.2-12.3-44.5 0L176 189.3 75.9 89.2c-12.3-12.3-32.2-12.3-44.5 0L9.2 111.5c-12.3 12.3-12.3 32.2 0 44.5L109.3 256 9.2 356.1c-12.3 12.3-12.3 32.2 0 44.5l22.2 22.2c12.3 12.3 32.2 12.3 44.5 0L176 322.7l100.1 100.1c12.3 12.3 32.2 12.3 44.5 0l22.2-22.2c12.3-12.3 12.3-32.2 0-44.5L242.7 256z"/></svg></i>
          </div>
        `);

        //optionElement.data('parent', opt);
        optionElement.data('parent-input', el);
        optionElement.click(function () {
          $(this).data('parent-input').val('');

          /* global woof_text_do_submit */
          woof_text_do_submit = true;

          /* global woof_text_direct_search */
          woof_text_direct_search('woof_text', '');
        });

        filtersSelectedPillsElement.append(optionElement);
      }

      let optionElementClick = function () {
        // On select this option
        console.log('click', this);
        let parent = $(this).data('parent');
        if (parent.prop('selected')) {
          parent.prop('selected', false);
        } else {
          parent.prop('selected', true);
        }

        $(this).data('parent-select').trigger('change');
        closeFilterElement($(this).closest('.ws-select'));

        /* global woof_current_values */
        //console.log(woof_current_values);
        let filterValues = {};
        for (let key in woof_current_values) {
          switch (key) {
            case 'page':
            case 'paged':
            case 'really_curr_tax':
              continue;
            default:
              filterValues[key] = woof_current_values[key];
              break;
          }
        }
        localStorage.setItem('wsFilterValues', JSON.stringify(filterValues));
        $(window).trigger('wsFilterValuesChange');
      }

      let toggleFilterElement = function(el) {
        if (el.hasClass('open')) {
          closeFilterElement(el);
        } else {
          openFilterElement(el);
        }
      }

      let openFilterElement = function(el) {
        if (el.hasClass('open')) {
          return;
        }

        el.addClass('open');
        $('body').addClass('ws-select-open');
      }

      let closeFilterElement = function(el) {
        if (!el.hasClass('open')) {
          return;
        }

        el.removeClass('open');
        $('body').removeClass('ws-select-open');
      }



      let toggleFilterWrapperElement = function() {
        if (filtersWrapperElement.hasClass('open')) {
          closeFilterWrapperElement();
        } else {
          openFilterWrapperElement();
        }
      }

      let openFilterWrapperElement = function() {
        if (filtersWrapperElement.hasClass('open')) {
          return;
        }

        filtersWrapperElement.addClass('open');
        $('body').addClass('ws-filters-wrapper-open');
      }

      let closeFilterWrapperElement = function() {
        if (!filtersWrapperElement.hasClass('open')) {
          return;
        }

        filtersWrapperElement.removeClass('open');
        $('body').removeClass('ws-filters-wrapper-open');
        $('body').removeClass('ws-select-open'); // TODO: Fix this properly
      }



      let initialize = function (filtersElementParameter) {
        filtersElement = $(filtersElementParameter);

        if (filtersElement.data('ws-filters')) {
          console.warn('Trying to reinitialize the filters for element. Skipping.', filtersElement);
          return;
        }
        filtersElement.data('ws-filters', this);

        mobileFiltersButtonElement = $('.mobile-filters');

        filtersWrapperElement = $(`
          <div class="ws-filters-wrapper">
            <div class="ws-filters-header">
              <div class="ws-filters-close-button">
                <i><svg xmlns="http://www.w3.org/2000/svg" height="1em" viewBox="0 0 320 512"><path d="M41.4 233.4c-12.5 12.5-12.5 32.8 0 45.3l160 160c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3L109.3 256 246.6 118.6c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0l-160 160z"/></svg></i>
                ${mobileFiltersButtonElement.text()}
              </div>
            </div>
            <div class="ws-filters"></div>
            <div class="ws-filters-selected-pills"></div>
          </div>
        `);
        filtersWrapperElement.insertBefore($('.wolky-rightcolumn .woocommerce.woocommerce-page'));
        filtersWrapperElement.find('.ws-filters').append($('.woocommerce-ordering, section.WOOF_Widget'));
        filtersWrapperElement.find('.ws-filters').append('<button class="ws-mobile-filter-result button"></button>');

        filtersSelectedPillsElement = filtersWrapperElement.find('.ws-filters-selected-pills');

        initializeFilters();
        bindEvents();
      };

      initialize(this);

      $(window).load(function () {
        initializeFilters();
      });
      $(window).resize(function () {
        initializeFilters();
      });
      $(document).on('woof-ajax-form-redrawing', function () {
        initializeFilters();
      });

      /* global translationsFilter */
      $(window).on('wsFilterValuesChange', function () {
        $(document).ajaxComplete(function(){
          let count = $('#woof_results_by_ajax').attr('data-count');
          let translationKey = (count === 1) ? 'mobileFilterTextTranslationSingle' : 'mobileFilterTextTranslationPlural';
          let mobileFilterResult = $('.ws-mobile-filter-result').text(translationsFilter[translationKey].replace('%s', count));

          if ($(window).width() <= 1024) {
            mobileFilterResult.show();
          }
        });
      });

      $(document).click(function ( event ) {
        // Close all except the current target
        let closestSelect = $(event.target).closest('.ws-select');
        closeFilterElement($('.ws-select').not(closestSelect));
      });
    });
  };
})(jQuery);
